import { render } from "./DocumentSearch.vue?vue&type=template&id=84f3f190"
import script from "./DocumentSearch.vue?vue&type=script&lang=js"
export * from "./DocumentSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__